import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../Button';
import { authAPI } from '../../api';
import './TopNav.css';

const TopNav = ({ activePage, onComposeClick }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user, setUser] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Get user data from localStorage
    const storedUser = authAPI.getStoredUser();
    console.log('Stored user data:', storedUser);
    setUser(storedUser);

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = async () => {
    try {
      await authAPI.logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      // Still navigate to login even if API call fails
      navigate('/login');
    }
  };

  const handleLogoClick = () => {
    if (user) {
      navigate('/dashboard');
    } else {
      navigate('/');
    }
  };

  // Generate profile image URL or use default
  const getProfileImageUrl = () => {
    if (user?.profile_image) {
      return user.profile_image;
    }
    // Create a default profile image with user's initials
    return `https://ui-avatars.com/api/?name=${user?.username || 'User'}&background=6366f1&color=fff&size=128`;
  };

  return (
    <header className="topnav">
      <div className="left">
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src="/logo-mark.png" alt="" className="logo-mark" aria-hidden="true" />
          <span className="logo-text">TRCKLE</span>
        </div>

        <nav className="main-links">
          <Link to="/dashboard" className={activePage === 'dashboard' ? 'active' : ''}>
            Dashboard
          </Link>
          <Link to="/scheduler" className={activePage === 'scheduler' ? 'active' : ''}>
            Publishing
          </Link>
          <Link to="/inbox" className={activePage === 'inbox' ? 'active' : ''}>
            Inbox
          </Link>
          <Link to="/posts" className={activePage === 'posts' ? 'active' : ''}>
            Posts
          </Link>
          <Link to="/analytics" className={activePage === 'analytics' ? 'active' : ''}>
            Analytics
          </Link>
          <Link to="/listening" className={activePage === 'listening' ? 'active' : ''}>
            Listening
          </Link>
        </nav>
      </div>

      <div className="right">
        <Button variant="compose" onClick={onComposeClick}>Compose</Button>
        
        <div className="profile-dropdown" ref={dropdownRef}>
          <img 
            src={getProfileImageUrl()} 
            alt="Profile" 
            className="profile" 
            onClick={toggleDropdown}
          />
          
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-header">
                <div className="dropdown-user-info">
                  <p className="dropdown-username">{user?.username || 'User'}</p>
                  <p className="dropdown-email">{user?.email || ''}</p>
                </div>
              </div>
              <div className="dropdown-divider"></div>
              <Link to="/settings" className="dropdown-item" onClick={() => setIsDropdownOpen(false)}>
                <span>Settings</span>
              </Link>
              <button className="dropdown-item logout" onClick={handleLogout}>
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopNav;
